import { useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Global watcher: toasts each new commission exactly once (server-acked),
// max 5/day (server-enforced). Polls on login + every 60s while online.
export default function CommissionAlerts() {
  const { user, token } = useAuth();
  const busy = useRef(false);

  useEffect(() => {
    if (!token || !user?.id) return undefined;
    const headers = { Authorization: `Bearer ${token}` };

    const check = async () => {
      if (busy.current) return;
      busy.current = true;
      try {
        const r = await axios.get(`${API_URL}/api/commissions/alerts`, { headers });
        const alerts = r.data?.alerts || [];
        if (alerts.length) {
          alerts.forEach((a) => {
            const amount = Number(a.amount || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2, maximumFractionDigits: 2,
            });
            const pct = a.percent ? `Your ${a.percent}% share` : 'Your commission';
            const kind = a.role === 'seller' ? 'listing sale' : 'downline sale';
            toast.success(`Commission earned: $${amount}`, {
              description: `${pct} from a ${kind} just hit your account.`,
              duration: 9000,
            });
          });
          await axios.post(
            `${API_URL}/api/commissions/alerts/ack`,
            { ids: alerts.map((a) => a.id) },
            { headers },
          );
        }
      } catch {
        /* silent — retried on next poll */
      } finally {
        busy.current = false;
      }
    };

    check();
    const t = setInterval(check, 60000);
    return () => clearInterval(t);
  }, [token, user?.id]);

  return null;
}
